export default __webpack_public_path__ + "static/media/AddPhotos.d3dce20e.svg";